var _circle, _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1430(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1992,
    cy: 9.5,
    r: 9,
    stroke: "#AEAEAE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.69922,
    y: 7,
    width: 2,
    height: 4,
    fill: "#AEAEAE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6992,
    y: 16,
    width: 2,
    height: 4,
    transform: "rotate(-180 12.6992 16)",
    fill: "#AEAEAE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.69922,
    y: 14,
    width: 2,
    height: 4,
    transform: "rotate(-90 8.69922 14)",
    fill: "#AEAEAE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6992,
    y: 7,
    width: 2,
    height: 4,
    fill: "#AEAEAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6992 4.5C11.6992 5.32843 11.0276 6 10.1992 6C9.37079 6 8.69922 5.32843 8.69922 4.5L8.69922 3L11.6992 3L11.6992 4.5Z",
    fill: "#AEAEAE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1430);
export default __webpack_public_path__ + "static/media/14-30.e5f0b216a36574591d326bf540388fe9.svg";
export { ForwardRef as ReactComponent };